import { strings } from "@quickpoint.me/shared";
import Viewerati from "@quickpoint.me/viewerati";
import { useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";
import { HostId } from "../../state/atoms";
import { StyledPreview } from "./PreviewPane";

function PortraitView(
  { showPortraitPreview }: { showPortraitPreview: boolean; showLandscapePreview: boolean },
) {
  const hostId = useRecoilValue(HostId);
  const ref = useRef<HTMLDivElement>(null);

  /* visual mirror only: out of the tab order and screen reader scope
     (React 18 has no `inert` prop, so set the DOM property directly) */
  useEffect(() => {
    if (ref.current) {
      ref.current.inert = true;
    }
  }, []);

  return (
    <StyledPreview
      ref={ref}
      className="portrait"
      data-testid="portrait-preview-pane"
      $show={showPortraitPreview}
      aria-hidden={true}
    >
      <div id={strings.css.portraitViewerID} className={`portrait-viewer ${strings.css.previewPane}`}>
        <Viewerati
          hostId={hostId}
          containerSelector={strings.css.portraitViewerID}
          isInPopOut={false}
          isInAuthor={true}
          isPreviewer={false}
        />
      </div>
    </StyledPreview>
  );
}

export default PortraitView;
